document.addEventListener('DOMContentLoaded', () => {
  const audioEl = document.getElementById('BvAudioElement');
  if (!audioEl) return;

  const promptDialog = document.getElementById('BvAudioPrompt');
  const toggleBtn = document.getElementById('BvAudioToggle');
  const iconPlay = toggleBtn.querySelector('.icon-play');
  const iconPause = toggleBtn.querySelector('.icon-pause');

  const audioChoice = sessionStorage.getItem('bv-audio-choice');
  const savedTime = sessionStorage.getItem('bv-audio-time');
  
  if (savedTime) {
    audioEl.currentTime = parseFloat(savedTime);
  }
  
  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem('bv-audio-time', audioEl.currentTime);
  });

  if (promptDialog) {
    // We are on the Senses page
    if (audioChoice === 'play' || audioChoice === 'skip') {
      if (audioChoice === 'play') {
        toggleBtn.classList.remove('hidden');
        audioEl.play().catch(() => {
          iconPause.classList.add('hidden');
          iconPlay.classList.remove('hidden');
        });
      } else {
        toggleBtn.classList.remove('hidden');
        iconPlay.classList.remove('hidden');
        iconPause.classList.add('hidden');
      }
    } else {
      promptDialog.showModal();
    }
  } else {
    // We are on a different page: Stop and pause audio playback completely
    if (audioEl) {
      audioEl.pause();
    }
  }

  if (promptDialog) {
    const playBtn = document.getElementById('BvAudioPlay');
    const skipBtn = document.getElementById('BvAudioSkip');
    const closePrompt = () => promptDialog.close();

    playBtn.addEventListener('click', () => {
      audioEl.play().then(() => {
        sessionStorage.setItem('bv-audio-choice', 'play');
        closePrompt();
        toggleBtn.classList.remove('hidden');
        iconPlay.classList.add('hidden');
        iconPause.classList.remove('hidden');
      }).catch(err => {
        console.warn("Audio playback failed:", err);
        closePrompt();
      });
    });

    skipBtn.addEventListener('click', () => {
      sessionStorage.setItem('bv-audio-choice', 'skip');
      closePrompt();
      toggleBtn.classList.remove('hidden');
      iconPlay.classList.remove('hidden');
      iconPause.classList.add('hidden');
    });
  }

  toggleBtn.addEventListener('click', () => {
    if (audioEl.paused) {
      audioEl.play();
      sessionStorage.setItem('bv-audio-choice', 'play');
      iconPlay.classList.add('hidden');
      iconPause.classList.remove('hidden');
    } else {
      audioEl.pause();
      sessionStorage.setItem('bv-audio-choice', 'skip');
      iconPause.classList.add('hidden');
      iconPlay.classList.remove('hidden');
    }
  });
});
